import { Config } from "src/Utils/ConfigService/LoadConfig";
import { usePostRequest } from "../ApiWrappers/usePostRequest";
import { useCallback, useEffect, useRef, useState } from "react";
import { v1 } from "src/Utils/ApiVersions";
import { logger } from "src/Utils/LoggerService/LoggerService";

export const useLicencePayment = () => {
    const {postRequest, reqestResponse, reqestError, reqestLoading} = usePostRequest();
    const [checkoutUrl, setCheckoutUrl]  = useState<string>('');
    const baseUrl = Config.GetConfigData().auraLicensingService.serviceUrl;
    const clinicIdRef = useRef<string>('');
    const createLicensePaymentPage = useCallback((priceId: string, clinicId: string) => {
        const requestUrl = `${baseUrl}api/${v1}/payment/clinic/${clinicId}/checkout`;
        logger.logInformation(`Request to create license payment page for the given clinic ${clinicId} was made`);
        postRequest<string>(priceId, requestUrl);
        clinicIdRef.current = clinicId;
    }, [baseUrl, postRequest]);

   useEffect(() => {
    if (reqestResponse) {
        logger.logInformation(`Check out page is generated for clinic: ${clinicIdRef?.current}`);
        setCheckoutUrl(reqestResponse.checkoutUrl);
      }
    }, [reqestResponse]);
    return {checkoutUrl, reqestError, reqestLoading, createLicensePaymentPage};
}
